import { render, staticRenderFns } from "./GemList.vue?vue&type=template&id=5fbef49e&scoped=true&"
import script from "./GemList.vue?vue&type=script&lang=js&"
export * from "./GemList.vue?vue&type=script&lang=js&"
import style0 from "./GemList.vue?vue&type=style&index=0&id=5fbef49e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbef49e",
  null
  
)

component.options.__file = "GemList.vue"
export default component.exports